import { render, staticRenderFns } from "./ProductsDetail.vue?vue&type=template&id=69276f02&scoped=true"
import script from "./ProductsDetail.vue?vue&type=script&lang=js"
export * from "./ProductsDetail.vue?vue&type=script&lang=js"
import style0 from "./ProductsDetail.vue?vue&type=style&index=0&id=69276f02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69276f02",
  null
  
)

export default component.exports